module.exports = __webpack_public_path__ + "img/hr-brown-fluff-05.18418add.png";